module.exports = __webpack_public_path__ + "static/media/ROUTE.f3102f5f.png";